export const LOGIN_USER = "LOGIN_USER";
export const SET_LOADING = "SET_LOADING";

//error
export const ERROR = "ERROR";

//get receipes
export const GET_RECEIPES = "GET_RECEIPES";

export const SEARCH = "SEARCH";
export const CLEAR_SEARCH = "SEARCH";

//update data
export const UPDATE_DATA = "UPDATE_DATA";

//get top receipes
export const GET_TOP_RECEIPES = "GET_TOP_RECEIPES";

//get undertated receipes
export const GET_UNDERATED_RECEIPES = "GET_UNDERATED_RECEIPES";

//get todays receipes
export const GET_TODAY_RECIEPES = "GET_TODAY_RECEIPES";
